




























































import Vue from "vue";
import Component from "vue-class-component";

import IconButton from "@/components/basic/IconButton.vue";

@Component<TimeTrackingDatatable>({
  components: {
    IconButton
  },
  props: {
    headers: {
      type: Array,
      default() {
        return [];
      }
    },
    tabletHeaders: {
      type: Array,
      default() {
        return [];
      }
    },
    mobileHeaders: {
      type: Array,
      default() {
        return [];
      }
    },
    items: {
      type: Array,
      default() {
        return [];
      }
    },
    title: {
      type: String,
      default: ""
    }
  }
})
export default class TimeTrackingDatatable extends Vue {
  private get tableHeaders() {
    return this.$vuetify.breakpoint.lgAndUp
      ? this.$props.headers
      : this.$vuetify.breakpoint.xsOnly
      ? this.$props.mobileHeaders.map((header: any) => {
          const mobileKey = "mobile";
          header[mobileKey] = true;
          return header;
        })
      : this.$props.tabletHeaders.length > 0
      ? this.$props.tabletHeaders.map((header: any) => {
          const tabletKey = "tablet";
          header[tabletKey] = true;
          return header;
        })
      : this.$props.headers;
  }

  private get cssProperties() {
    return {
      "--primary-color": this.$vuetify.theme.currentTheme.primary + "90"
    };
  }

  public rowClicked(event: any) {
    this.$emit("row-clicked", event);
  }
}
